import React from 'react';
import {colors} from '../theme/tokens/colors';

export interface RightArrowIconProps {
  color?: keyof typeof colors;
  size?: number;
}

export const RightArrowIcon = React.memo<RightArrowIconProps>(
  ({color = 'textLow', size = 10}) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.65102 7.85707L9.50102 4.00707L5.65102 0.143066H4.12502L7.42902 3.43307H0.499023V4.58107H7.42902L4.12502 7.85707H5.65102Z"
        fill={colors[color] || color}
      />
    </svg>
  ),
);
